export var GuildActionsName;
(function (GuildActionsName) {
    GuildActionsName["BAN_USER"] = "banUser";
    GuildActionsName["ACTIVATE_USER"] = "activateUser";
    GuildActionsName["CREATE_GUILD"] = "createGuild";
    GuildActionsName["JOIN_GUILD"] = "joinGuild";
    GuildActionsName["LEAVE_GUILD"] = "leaveGuild";
    GuildActionsName["DELETE_GUILD"] = "deleteGuild";
    GuildActionsName["MAKE_OWNER"] = "makeOwner";
    GuildActionsName["REQUEST"] = "request";
    GuildActionsName["CANCEL_REQUEST"] = "cancelRequest";
    GuildActionsName["MAKE_ADMIN"] = "makeAdmin";
    GuildActionsName["REVOKE_ADMIN"] = "revokeAdmin";
    GuildActionsName["GET_MY_GUILD"] = "getMyGuild";
    GuildActionsName["GET_MEMBERS"] = "getMembers";
    GuildActionsName["GET_ALL_GUILDS"] = "getAllGuilds";
    GuildActionsName["DELETE_USER_FROM_GUILD"] = "deleteUserFromGuildAction";
    GuildActionsName["GET_ONE_GUILD"] = "getOneGuild";
    GuildActionsName["EDIT_GUILD"] = "editGuild";
})(GuildActionsName || (GuildActionsName = {}));
export var PrivacyType;
(function (PrivacyType) {
    PrivacyType["PRIVATE"] = "private";
    PrivacyType["OPEN"] = "open";
})(PrivacyType || (PrivacyType = {}));
export var RequestStatusType;
(function (RequestStatusType) {
    RequestStatusType["PENDING"] = "pending";
})(RequestStatusType || (RequestStatusType = {}));
export var MembersType;
(function (MembersType) {
    MembersType["MEMBER"] = "member";
    MembersType["ADMIN"] = "admin";
    MembersType["OWNER"] = "owner";
})(MembersType || (MembersType = {}));
